export const HeroinputErrorDiv = {
  textAlign: 'center',
  margin: '0 auto',
  width: '100%',
  position: 'relative',
};

export const CardinputErrorDiv = {
  textAlign: 'center',
  margin: '0 auto',
  width: '80%',
  position: 'relative',
};

export const HeroinputArrow = {
  display: 'inline-block',
  float: 'right',
  position: 'relative',
  bottom: '25px',
  paddingRight: '10px',
};

export const HerotextInput = {
  width: '80%',
  marginTop: '-44px',
  borderRight: '0',
  borderTopRightRadius: '0',
  borderBottomRightRadius: '0',
};

export const InputFieldContainer = {
  background: 'white',
  borderTopLeftRadius: '5px',
  borderTopRightRadius: '5px',
  borderBottomLeftRadius: '5px',
  borderBottomRightRadius: '5px',
};

export const HeroInput = {
  width: '100%',
  borderTopLeftRadius: '5px',
  borderTopRightRadius: '5px',
  borderBottomLeftRadius: '5px',
  borderBottomRightRadius: '5px',
  boxShadow: 'none',
  height: '50px',
  border: 'none',
  padding: '0 0 0 18px',
  background: 'transparent',
};

export const HeroUl = {
  display: 'block',
  zIndex: '2500',
  // width: '23.8%'
};

export const HeroUlMobile = {
  display: 'block',
  // width: '78.4%'
};

export const CardInput = {
  // borderRadius: '5px',
  borderTopLeftRadius: '5px',
  borderTopRightRadius: '5px',
  borderBottomLeftRadius: '5px',
  borderBottomRightRadius: '5px',
  height: '40px',
  border: '1px solid #d4d9dc',
  padding: '0 0 0 16px', // 18px
  fontSize: '16px',
  width: '80%', // 100%
};

export const HubCardInput = {
  // borderRadius: '5px',
  borderTopLeftRadius: '5px',
  borderTopRightRadius: '5px',
  borderBottomLeftRadius: '5px',
  borderBottomRightRadius: '5px',
  height: '40px',
  border: '1px solid #d4d9dc',
  padding: '0 0 0 18px', // 18px
  fontSize: '16px',
  // lineHeight: '1',
  width: '100%', // 100%
};

export const InputBorderDrop = {
  borderBottomLeftRadius: '0',
  borderBottomRightRadius: '0',
};

export const CardinputArrow = {
  display: 'inline-block',
  float: 'right',
  position: 'relative',
  left: '40px',
  paddingRight: '52px',
  bottom: '20px',
  cursor: 'default',
};

export const CardUl = {
  display: 'block',
  // marginTop: '34px'
  marginBottom: '-1px',
};

export const CardInputContainer = {
  height: '35px',
  position: 'relative',
  zIndex: '1',
  width: '100%', // 80%
  margin: '0 auto',
  textAlign: 'center',
  // paddingLeft:'28px'
};

export const HubCardInputContainer = {
  height: '35px',
  position: 'relative',
  zIndex: '1',
  width: '80%',
  margin: '0 auto',
  textAlign: 'center',
  // paddingLeft:'28px'
};

export const NPOpageInputContainer = {
  width: '100%',
};

export const CardInputBox = {
  paddingLeft: '20px',
};

export const navLinkMobileUl = {
  width: '75%',
};

export const navLinkMobileInput = {
  border: '1px solid black',
};

export const navLinkMobileInputCont = {
  width: '75%',
  margin: '0 auto',
  textAlign: 'center',
};

const dataUrlArrow =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoxMjhDQUY2RjQ4RjcxMUU1QkIzNUVGNzFBNTcxOEQ4MCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoxMjhDQUY3MDQ4RjcxMUU1QkIzNUVGNzFBNTcxOEQ4MCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjEyOENBRjZENDhGNzExRTVCQjM1RUY3MUE1NzE4RDgwIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjEyOENBRjZFNDhGNzExRTVCQjM1RUY3MUE1NzE4RDgwIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+XITWJgAAARtJREFUeNrs2dENgjAQBmAwbsAaPoAkLqA+uIAOpfv4oA8uQOIgMAOeSZsQIlra/6rB/5J7ABKuH4H2gLRt22QKMUsmEoQQQgghhBBCCCGEEPI/kPnQgaqqfnLAZVny1lpKXiWzL4wvM7ULBOQouZa8RMZkpuaz9gkBOUjezVWJhbGIwtTeIyC15DYipo/YSDao6TcWxgsxdtaqzYm1MN0HexTCZ/ptlDAWkfsgfNcRNCYYEbIgojAQROjKHoqBIRAtSh/j2gFAEaheq4vJHTBwBLJpdMWoINDd7yeMGkKjjR/CqCLevlgBMHbgN7N/oYXQgrzCJJoITUgXczbbOy2ENsRiVvyKMiJS/tUlhBBCCCGEEEIIUYuHAAMAg89oVszT+ikAAAAASUVORK5CYII=';
const dataUrlClose =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAQAAABu4E3oAAAFFWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS41LWMwMTIgMS4xNDk2MDIsIDIwMTIvMTAvMTAtMTg6MTA6MjQgICAgICAgICI+CiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogIDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiCiAgICB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iCiAgICB4bWxuczpkYW09Imh0dHA6Ly93d3cuZGF5LmNvbS9kYW0vMS4wIgogICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iCiAgICB4bWxuczpQYXlQYWw9Ind3dy5wYXlwYWwuY29tL2Jhc2UvdjEiCiAgIGRjOmZvcm1hdD0iaW1hZ2UvcG5nIgogICBkYzptb2RpZmllZD0iMjAxMy0xMi0xMFQxNTo0ODo1Ny41MjEtMDg6MDAiCiAgIGRhbTpzaXplPSIxNzEiCiAgIGRhbTpQaHlzaWNhbHdpZHRoaW5pbmNoZXM9Ii0xLjAiCiAgIGRhbTpleHRyYWN0ZWQ9IjIwMTMtMTItMTBUMTU6NDg6NTYuMTYxLTA4OjAwIgogICBkYW06c2hhMT0iZjQwZTM2OGI1NmNlMDdhZDRlNWNlY2ZiNGY5NDQxZmU1YjM3NDFjMiIKICAgZGFtOk51bWJlcm9mdGV4dHVhbGNvbW1lbnRzPSIwIgogICBkYW06RmlsZWZvcm1hdD0iUE5HIgogICBkYW06UHJvZ3Jlc3NpdmU9Im5vIgogICBkYW06UGh5c2ljYWxoZWlnaHRpbmRwaT0iLTEiCiAgIGRhbTpNSU1FdHlwZT0iaW1hZ2UvcG5nIgogICBkYW06TnVtYmVyb2ZpbWFnZXM9IjEiCiAgIGRhbTpCaXRzcGVycGl4ZWw9IjE2IgogICBkYW06UGh5c2ljYWxoZWlnaHRpbmluY2hlcz0iLTEuMCIKICAgZGFtOlBoeXNpY2Fsd2lkdGhpbmRwaT0iLTEiCiAgIHRpZmY6SW1hZ2VMZW5ndGg9IjI1IgogICB0aWZmOkltYWdlV2lkdGg9IjI1IgogICBQYXlQYWw6c3RhdHVzPSJTb3VyY2VBcHByb3ZlZCIKICAgUGF5UGFsOnNvdXJjZU5vZGVQYXRoPSIvY29udGVudC9kYW0vUGF5UGFsRGlnaXRhbEFzc2V0cy9zcGFydGFJbWFnZXMvR2xvYmFsSW1hZ2VzL21rdGcvMjAxNGRlc2lnbi9jbG9zZV9kZWZhdWx0LnBuZyIKICAgUGF5UGFsOmlzU291cmNlPSJ0cnVlIj4KICAgPGRjOmxhbmd1YWdlPgogICAgPHJkZjpCYWcvPgogICA8L2RjOmxhbmd1YWdlPgogIDwvcmRmOkRlc2NyaXB0aW9uPgogPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KPD94cGFja2V0IGVuZD0iciI/PhESLTAAAABySURBVHgBzdIxCoAwFATRtZCACYpoITaCl9BjeP/T2AnB4W+b6V+K7Ff7FcVN6lWVdGkNwKz7/2hm9IFRECMGjBg4xIARA4MQGHSGANr16BAUDbeZcfFbc4gAyCIAHgFgxMAjBgYVBhVaVNVpsBeR1HYvtcwLhzoX1iQAAAAASUVORK5CYII=';

export const navLinkArrow = {
  float: 'left',
  opacity: '1',
  width: '40px',
  height: '40px',
  marginTop: '7px',
  backgroundSize: '75% 75%',
  backgroundRepeat: 'no-repeat',
  marginLeft: '5px',
  backgroundImage: 'url(' + dataUrlArrow + ')',
  backgroundPosition: '50% 50%',
  MozTransition: 'all 300ms ease',
  WebkitTransition: 'all 300ms ease',
  OTransition: 'all 300ms ease',
  transition: 'all 300ms ease',
};

export const navLinkClose = {
  // float:'left',
  opacity: '1',
  width: '35px',
  height: '35px',
  backgroundSize: '25px 25px',
  backgroundImage: 'url(' + dataUrlClose + ')',
};

export const rotate = {
  WebkitTransform: 'rotate(180deg)',
  MsTransform: 'rotate(180deg)',
  OTransition: 'rotate(180deg)',
  transform: 'rotate(180deg)',
  opacity: '0',
};

export const HerocurrencySymbolStyle = {
  display: 'inline-block',
  float: 'left',
  position: 'relative',
  bottom: '33px',
  left: '7px',
  height: '0',
  fontSize: '16px',
  lineHeight: '1',
  color: '#2c2e2f',
  // color: 'var(--dark-grey)'
};

export const CardcurrencySymbolStyle = {
  display: 'inline-block',
  float: 'left',
  position: 'relative',
  top: '12px', // -28
  left: '34px', // 7px
  height: '0',
  fontSize: '16px',
  lineHeight: '1',
  color: '#2c2e2f',
};

export const HubCardcurrencySymbolStyle = {
  display: 'inline-block',
  float: 'left',
  position: 'relative',
  top: '-28px', // -28
  left: '7px', // 7px
  height: '0',
  fontSize: '16px',
  lineHeight: '1',
  color: '#2c2e2f',
};

export const ModalInputDiv = {
  // 81%
  width: '56%',
  minWidth: '300px',
  height: '44px',
  border: 'solid 1px #9da3a6',
  margin: '0 auto',
  borderRadius: '2px',
};

export const InputOverlay = {
  float: 'left',
  width: '81%',
  height: '42px',
  color: '#7b8388',
  fontSize: '15px',
  paddingLeft: '15px',
  display: 'block',
  margin: '0 auto',
  borderTop: 'none',
  borderBottom: 'none',
  borderLeft: 'none',
  borderRight: '1px solid #9da3a6',
  borderRadiusTopRight: 'none',
  borderRadiusTopBottom: 'none',
  borderBottomRightRadius: '0',
  borderTopRightRadius: '0',
};

export const InputOverlayMobileWidth = {
  width: '75%',
};

export const centeredLogos = {
  textAlign: 'center',
  paddingLeft: 0,
};

export const popularCharityHeight = {
  height: '750px',
  overflow: 'hidden',
};
